module.exports = __webpack_public_path__ + "static/media/Columbus_Blue_Jackets.78bd6b69.svg";